export default "__VITE_ASSET__3PFgOOXC__"